import { combineReducers } from "redux";
import configuration from "./configuration";
import units from "./units";

export default combineReducers({
  configuration,
  units,
});
